import { render, staticRenderFns } from "./ApiSubjectCard.vue?vue&type=template&id=238b8bd2&"
import script from "./ApiSubjectCard.vue?vue&type=script&lang=js&"
export * from "./ApiSubjectCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports